import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPaidOfficeSummaryReport extends Layout {
    checkboxEmailSummaries: Checkbox;
    checkboxPostedPayments: Checkbox;
    excludabletextboxDivision: ExcludableTextbox;
    excludabletextboxJobClass: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    excludabletextboxTerminal: ExcludableTextbox;
    labelDash: Label;
    sourcePaidSettlements: DataSource;
    switchCheckRange: Switch;
    textboxCheckRangeEnd: Textbox;
    textboxCheckRangeStart: Textbox;
    textboxDateRange: Textbox;
}
